export default "__VITE_PUBLIC_ASSET__c33864ce__"